import React from "react";

import type { Url } from "../../../../../types/content";
import type { LayoutType } from "../../../../../utils/layout";

import { Video } from "../../../../Video/Video";

const ArticleVideo = ({
  resource,
  layoutType,
  isGrouped,
  isFirst = false,
  isMainResource = false,
}: {
  resource: Url;
  layoutType?: LayoutType;
  isGrouped?: boolean;
  isFirst?: boolean;
  isMainResource?: boolean;
}) => {
  return (
    <Video
      resource={resource}
      layoutType={layoutType}
      isGrouped={isGrouped}
      isFirst={isFirst}
      isMainResource={isMainResource}
    />
  );
};

export { ArticleVideo };
